<template>
  <div class="preview" :class="{ 'preview--fullsize': !this.short }">
    <div class="preview__upper">
      <div class="preview__upper-img">
        <img class="preview__upper-icon icon" src="@/create/assets/icons/logo-sm-square.svg">
      </div>
      <div class="preview__upper-text">
        <div class="preview__upper-title">МАКС-Жизнь страховая компания</div>
        <div class="preview__upper-subtitle">Гарантия плюс доход</div>
      </div>
    </div>
    <template v-if="!this.short">
      <div class="preview__cards preview__cards--sm">
        <div class="preview__card">100% защита капитала</div>
        <div class="preview__card">гарантированный доход</div>
      </div>
      <div class="preview__cards preview__cards--big">
        <div class="preview__card">
          <div class="preview__card-img">
            <img class="preview__card-icon icon" src="@/create/assets/icons/schedule.svg">
          </div>
          <div class="preview__card-text">
            <div class="preview__card-title">Ежегодно</div>
            <div class="preview__card-subtitle">Выплата дохода</div>
          </div>
        </div>
        <div class="preview__card">
          <div class="preview__card-img">
            <img class="preview__card-icon icon" src="@/create/assets/icons/rouble.svg">
          </div>
          <div class="preview__card-text">
            <div class="preview__card-title">От 100 000
              <nobr>до 1 000 000 ₽</nobr>
            </div>
            <div class="preview__card-subtitle">Взнос</div>
          </div>
        </div>
        <div class="preview__card">
          <div class="preview__card-img">
            <img class="preview__card-icon icon" src="@/create/assets/icons/person.svg">
          </div>
          <div class="preview__card-text">
            <div class="preview__card-title">18-70 лет</div>
            <div class="preview__card-subtitle">Возраст застрахованного</div>
          </div>
        </div>
      </div>
      <div class="preview__heading">Гарантированный доход от взноса*</div>
      <div class="preview__table">
        <div class="preview__table-row">
          <div class="preview__table-data">Срок</div>
          <div class="preview__table-data">Гарантия
            <nobr>от первого</nobr>
            взноса
          </div>
          <div class="preview__table-data">Гарантия
            <nobr>от второго</nobr>
            взноса
          </div>
          <div class="preview__table-data">Гарантия
            <nobr>от третьего</nobr>
            взноса
          </div>
        </div>
        <div class="preview__table-row">
          <div class="preview__table-data">2 года</div>
          <div class="preview__table-data">19%</div>
          <div class="preview__table-data">19%</div>
          <div class="preview__table-data">-</div>
        </div>
        <div class="preview__table-row">
          <div class="preview__table-data">3 года</div>
          <div class="preview__table-data">25%</div>
          <div class="preview__table-data">25%</div>
          <div class="preview__table-data">25%</div>
        </div>
      </div>
      <div class="preview__subtitle">
        * Подробнее о страховых рисках и выплатах уточните у специалиста
      </div>
      <div class="preview__cards preview__cards--med">
        <div class="preview__card">
          <div class="preview__card-img">
            <img class="preview__card-icon icon" src="@/create/assets/icons/shield-rouble.svg">
          </div>
          <div class="preview__card-text">100% защита капитала</div>
        </div>
        <div class="preview__card">
          <div class="preview__card-img">
            <img class="preview__card-icon icon" src="@/create/assets/icons/list-percent.svg">
          </div>
          <div class="preview__card-text">доход гарантирован</div>
        </div>
        <div class="preview__card">
          <div class="preview__card-img">
            <img class="preview__card-icon icon" src="@/create/assets/icons/lock-rouble.svg">
          </div>
          <div class="preview__card-text">24/7 страховая защита</div>
        </div>
      </div>
      <div class="preview__buttons">
        <button @click="this.$emit('wrap')"
                class="preview__button button button--sravni button--largetext button--col text-r mb20">
          <span>Оформить онлайн</span>
          <span>с идентификацией на портале
            <img style="max-height: 1.1em; transform: translate(3.5px, 4.5px);"
                 src="@/create/assets/icons/gosuslugi.svg" alt="ГосУслуги">
          </span>
        </button>
<!--        <p class="preview__link">-->
<!--          Также вы можете <a href="https://makclife.ru/sravniru/" class="clp-link clp-link&#45;&#45;sravni">оставить заявку</a>-->
<!--          и вам перезвонит сотрудник страховой компании-->
<!--        </p>-->
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['short'],
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";

</style>
